export function getValues(map, ...keys) {
  return keys.map(k => map.get(k));
}

export const get = (p, o) =>
  p.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), o);



// WEBPACK FOOTER //
// ./app/lib/maps.js